require("./bootstrap");

import route from "ziggy";
import { Ziggy } from "./ziggy";

import { createApp, h } from "vue";
import { App, plugin } from "@inertiajs/inertia-vue3";

import languageBundle from "@kirschbaum-development/laravel-translations-loader?parameters={$1}!@kirschbaum-development/laravel-translations-loader";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
    locale: window.locale,
    fallbackLocale: window.fallback_locale,
    messages: languageBundle,
});

const el = document.getElementById("app");

createApp({
    render: () =>
        h(App, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) =>
                import(`./Pages/${name}`).then((module) => module.default),
        }),
})
    .mixin({
        methods: {
            route: (name, params, absolute, config = Ziggy) =>
                route(name, params, absolute, config),
        },
    })
    .use(plugin)
    .use(i18n)
    .mount(el);
